export const FEATURE_NAMES = {
  sessionReplay: 'session_replay',
  sessionTrace: 'session_trace',
  webVitals: 'web_vitals',
  resourceTiming: 'resource_timing',
  heaviestResources: 'heaviest_resources',
  failedLoadResources: 'failed_load_resources',
  domCapture: 'dom_capture',
};
